import React from 'react';

import { bemCssModules, correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';

import { getTestId } from '@utils';

import { useStore } from '@modules';
import { FiatCurrencyEnum } from '@modules/global/types';

import style from './Balance.scss';

const cn = bemCssModules(style, 'Balance');
const ti = getTestId('Balance');

export const Balance: CustomFC = ({ className }) => {
  const [{ global, accounts }] = useStore();
  const currency = FiatCurrencyEnum.EUR;

  const totalDigits = global.currencies.config.display_options[currency]?.total_digits;
  const displayDigits = global.currencies.config.display_options[currency]?.display_digits;
  const fiatBalance = accounts.details[0]?.fiat_balance || 0;

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('main-balance')}>
        <p className={cn('fiat')}>
          {correctingTrailingNumbers(fiatBalance, displayDigits, totalDigits)}{' '}
          <span className={cn('currency-fiat')}>{currency}</span>
        </p>
      </div>
    </div>
  );
};

export default Balance;
